import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import Select from "react-select";
import { getSchoolYear, getSchoolYearB, setSchoolYear, setSchoolYearB } from "../../api/crud";
import { updateSnackbar } from "../../redux/action/dataAction";

const AdminSettings = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [currentYear, setCurrentYear] = useState(null); // Internship
  const [selectedYear, setSelectedYear] = useState(null);
  const [localOverride, setLocalOverride] = useState(null);

  const [currentYearDsbi, setCurrentYearDsbi] = useState(null); // Cooperative
  const [selectedYearDsbi, setSelectedYearDsbi] = useState(null);
  const [localOverrideDsbi, setLocalOverrideDsbi] = useState(null);

  useEffect(() => {
    const init = async () => {
      try {
  const res = await getSchoolYear();
  setCurrentYear(res?.school_yrs);
  setSelectedYear(res?.school_yrs);
  const local = localStorage.getItem("adminSchoolYearOverride");
  if (local) setLocalOverride(parseInt(local, 10));

  const resB = await getSchoolYearB();
  setCurrentYearDsbi(resB?.school_yrs);
  setSelectedYearDsbi(resB?.school_yrs);
  const localB = localStorage.getItem("adminSchoolYearDsbiOverride");
  if (localB) setLocalOverrideDsbi(parseInt(localB, 10));
      } catch (e) {
        console.error(e);
        dispatch(
          updateSnackbar({ open: true, content: "โหลดปีการศึกษาไม่สำเร็จ" })
        );
      } finally {
        setLoading(false);
      }
    };
    init();
  }, [dispatch]);

  const options = useMemo(() => {
    const base = Number(currentYear) || new Date().getFullYear() + 543; // TH year fallback
    // Show next year first (base + 1), then base and previous 3 years
    return [1, 0, -1, -2, -3].map((offset) => {
      const y = base + offset;
      const label = offset === 1 ? `${y} (ปีถัดไป)` : `${y}`;
      return { value: y, label };
    });
  }, [currentYear]);

  const optionsDsbi = useMemo(() => {
    const base = Number(currentYearDsbi) || new Date().getFullYear() + 543;
    return [1, 0, -1, -2, -3].map((offset) => {
      const y = base + offset;
      const label = offset === 1 ? `${y} (ปีถัดไป)` : `${y}`;
      return { value: y, label };
    });
  }, [currentYearDsbi]);

  const onSaveGlobal = async () => {
    try {
      console.log('Attempting to save school year:', selectedYear);
      const result = await setSchoolYear(selectedYear);
      console.log('Save result:', result);
      dispatch(updateSnackbar({ open: true, content: "บันทึกปีการศึกษา (ฝึกงาน) สำเร็จ" }));
    } catch (e) {
      console.error('Save failed:', e);
      const errorMsg = e?.response?.data?.message || e?.message || 'Unknown error';
      dispatch(updateSnackbar({ open: true, content: `บันทึกไม่สำเร็จ: ${errorMsg}` }));
    }
  };

  const onSaveGlobalDsbi = async () => {
    try {
      console.log('Attempting to save DSBI school year:', selectedYearDsbi);
      const result = await setSchoolYearB(selectedYearDsbi);
      console.log('Save DSBI result:', result);
      dispatch(updateSnackbar({ open: true, content: "บันทึกปีการศึกษา (สหกิจ) สำเร็จ" }));
    } catch (e) {
      console.error('Save DSBI failed:', e);
      const errorMsg = e?.response?.data?.message || e?.message || 'Unknown error';
      dispatch(updateSnackbar({ open: true, content: `บันทึกไม่สำเร็จ: ${errorMsg}` }));
    }
  };

  const onApplyLocal = () => {
    if (!selectedYear) return;
    localStorage.setItem("adminSchoolYearOverride", String(selectedYear));
    setLocalOverride(selectedYear);
    dispatch(
      updateSnackbar({
        open: true,
        content: `ตั้งค่าปีการศึกษา (เฉพาะเครื่องนี้): ${selectedYear}`,
      })
    );
  };

  const onApplyLocalDsbi = () => {
    if (!selectedYearDsbi) return;
    localStorage.setItem("adminSchoolYearDsbiOverride", String(selectedYearDsbi));
    setLocalOverrideDsbi(selectedYearDsbi);
    dispatch(updateSnackbar({ open: true, content: `ตั้งค่าสหกิจ (เฉพาะเครื่องนี้): ${selectedYearDsbi}` }));
  };

  const onClearLocal = () => {
    localStorage.removeItem("adminSchoolYearOverride");
    setLocalOverride(null);
    dispatch(
      updateSnackbar({ open: true, content: "ลบการตั้งค่าเฉพาะเครื่องแล้ว" })
    );
  };

  const onClearLocalDsbi = () => {
    localStorage.removeItem("adminSchoolYearDsbiOverride");
    setLocalOverrideDsbi(null);
    dispatch(updateSnackbar({ open: true, content: "ลบการตั้งค่าสหกิจ (เฉพาะเครื่อง) แล้ว" }));
  };

  return (
    <div className="container-fluid p-3 p-md-4">
      <div className="card shadow-sm">
        <div className="card-header bg-light">
          <h4 className="mb-0">ตั้งค่าระบบฝึกงาน (Admin)</h4>
        </div>
        <div className="card-body">
          <h5 className="mb-3">ปีการศึกษา</h5>

          {loading ? (
            <div className="text-muted">กำลังโหลด...</div>
          ) : (
            <>
              {/* Internship Year */}
              <div className="row g-3 align-items-center mb-3">
                <div className="col-md-4 col-12">
                  <label className="form-label text-muted">ค่าปัจจุบัน (จากระบบ)</label>
                  <div className="form-control bg-light">{currentYear ?? '-'}</div>
                </div>
                <div className="col-md-4 col-12">
                  <label className="form-label">เลือกปีการศึกษาใหม่</label>
                  <Select
                    options={options}
                    value={options.find((o) => o.value === selectedYear) || null}
                    onChange={(opt) => setSelectedYear(opt?.value)}
                    placeholder="เลือกปีการศึกษา"
                  />
                </div>
                <div className="col-md-4 col-12 d-flex gap-2 mt-3 mt-md-4">
                  <button className="btn btn-primary" onClick={onSaveGlobal}>
                    บันทึก (Global)
                  </button>
                  <button className="btn btn-outline-secondary" onClick={onApplyLocal}>
                    ใช้ชั่วคราว (เครื่องนี้)
                  </button>
                  <button className="btn btn-outline-danger" onClick={onClearLocal}>
                    ลบค่าเครื่องนี้
                  </button>
                </div>
              </div>

              <hr className="my-4" />

              {/* Cooperative Year (DSBI) */}
              <h6 className="mb-2">สหกิจศึกษา (DSBI)</h6>
              <div className="row g-3 align-items-center mb-3">
                <div className="col-md-4 col-12">
                  <label className="form-label text-muted">ค่าปัจจุบัน (จากระบบ)</label>
                  <div className="form-control bg-light">{currentYearDsbi ?? '-'}</div>
                </div>
                <div className="col-md-4 col-12">
                  <label className="form-label">เลือกปีการศึกษาใหม่</label>
                  <Select
                    options={optionsDsbi}
                    value={optionsDsbi.find((o) => o.value === selectedYearDsbi) || null}
                    onChange={(opt) => setSelectedYearDsbi(opt?.value)}
                    placeholder="เลือกปีการศึกษา (DSBI)"
                  />
                </div>
                <div className="col-md-4 col-12 d-flex gap-2 mt-3 mt-md-4">
                  <button className="btn btn-primary" onClick={onSaveGlobalDsbi}>
                    บันทึก (Global)
                  </button>
                  <button className="btn btn-outline-secondary" onClick={onApplyLocalDsbi}>
                    ใช้ชั่วคราว (เครื่องนี้)
                  </button>
                  <button className="btn btn-outline-danger" onClick={onClearLocalDsbi}>
                    ลบค่าเครื่องนี้
                  </button>
                </div>
              </div>

              <div className="alert alert-info">
                <div className="fw-bold mb-1">หมายเหตุ</div>
                <ul className="mb-0">
                  <li>การกด "บันทึก (Global)" ต้องเชื่อมต่อ API ของฝั่งเซิร์ฟเวอร์ เพื่อเปลี่ยนปีการศึกษาให้ทุกคน</li>
                  <li>ปุ่ม "ใช้ชั่วคราว (เครื่องนี้)" จะตั้งค่าปีการศึกษาเฉพาะในเบราว์เซอร์นี้เท่านั้น เพื่อทดสอบการทำงานหน้าต่างๆ</li>
                </ul>
              </div>

              {localOverride && (
                <div className="alert alert-warning mt-3">
                  ใช้ค่าเฉพาะเครื่องอยู่: ปีการศึกษา {localOverride}
                </div>
              )}

              {localOverrideDsbi && (
                <div className="alert alert-warning mt-2">
                  ใช้ค่าเฉพาะเครื่อง (สหกิจ): ปีการศึกษา {localOverrideDsbi}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminSettings;
